/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Pump_OffInputs */

const vi_irrigation_devices_pump_off = /** @type {(inputs: Irrigation_Devices_Pump_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tắt`)
};

/**

* @param {Irrigation_Devices_Pump_OffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_pump_off = /** @type {((inputs?: Irrigation_Devices_Pump_OffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Pump_OffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_pump_off(inputs)
});